import React, { useState, useEffect } from 'react';
import tagsService from '../../services/tagsService';
import { toast } from 'react-toastify';
import './TagColorPicker.css';

const TagColorPicker = ({ selectedColor, onColorSelect }) => {
  const [colors, setColors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadColors();
  }, []);

  const loadColors = async () => {
    try {
      setLoading(true);
      const response = await tagsService.getTagColors();
      setColors(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar paleta de cores:', error);
      toast.error('Erro ao carregar paleta de cores');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="tagColorPicker">
        <p className="tagColorPicker__loading">Carregando cores...</p>
      </div>
    );
  }

  return (
    <div className="tagColorPicker">
      <div className="tagColorPicker__grid">
        {colors.map((color) => (
          <button
            key={color.id}
            className={`tagColorPicker__color ${
              selectedColor === color.colorHex ? 'tagColorPicker__color--selected' : ''
            }`}
            style={{ backgroundColor: color.colorHex }}
            onClick={() => onColorSelect(color.colorHex)}
            aria-label={`Selecionar cor ${color.colorHex}`}
          >
            {selectedColor === color.colorHex && (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.3333 4L6 11.3333L2.66667 8"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TagColorPicker;

